import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISemester } from '../../../models/semesters.model';
import _ from 'lodash';

import { Table, TableColumnsType } from 'antd';


import Loader from '../../Loader';
import moment from 'moment';
import DownloadButton from '../../DownloadButton';
import Pagination from '../../Pagination';
import config from '../../../lib/config';
import exportTable from '../../../lib/exportTable';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  semesters: any;
  semesterData: any;
  monthInputInit: any;
  setMonthInput: any;
  onSetSemester: any;
  getSemesterMonths: any;
  getSemesterCourses: any;
  setChosenCourse: any;
  param: any;
  page: any;
}

const SemesterTable: FC<IProps> = ({
  semesters,
  semesterData,
  monthInputInit,
  setMonthInput,
  onSetSemester,
  getSemesterMonths,
  getSemesterCourses,
  setChosenCourse,
  param,
  page,
}) => {
  const { t } = useTranslation();
  const [exportTableLoading, setExportTableLoading] = useState(false);
  const [semesterCode, setSemesterCode] = useState<any>();

  const onExportTable = () => {
    setExportTableLoading(true);
    const data = _.cloneDeep(semesterData);
    data.forEach((semester: any) => {
      // 유형 열 변환
      semester.semesterType = getCommonCodeLabel('PR0002', semester.semesterType, 'ko');
    });
    const currentDate = moment(new Date());
    exportTable(columns, data, `${t('program.semester.title1')}_(${currentDate.format('YYYYMMDD')})`, `${t('program.semester.title1')}`, [25, 10] );
    setExportTableLoading(false);
  }

  const columns: TableColumnsType<ISemester> = [
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
      align: 'center'
    },
    {
      title: t('program.semester.column33'),
      dataIndex: 'semesterType',
      key: 'semesterType',
      sorter: (a, b) => a.semesterType?.localeCompare(b.semesterType),
      render: (value: string) => getCommonCodeLabel('PR0002', value, 'ko'),
      align: 'center'
    },
  ];

  return (
    <div>
      {exportTableLoading ? <Loader /> : null}
      <div className="card">
        <div className="card-header">
          {t('common.text.count')}: {semesterData?.length}{t('common.text.unit')}
        </div>
        <div className="card-body table-wrapper">
          <Table
            columns={columns}
            dataSource={semesterData || undefined}
            pagination={{
              current: page,
              pageSize: config.smallPageSize
            }}
            onRow={(record: any) => {
              return {
                onClick: () => {
                  setSemesterCode(record.semesterCode);
                  setMonthInput(monthInputInit);
                  onSetSemester(record.semesterCode);
                  getSemesterMonths(record.semesterCode);
                  getSemesterCourses(record.semesterCode);
                  setChosenCourse(null);
                }
              };
            }}
            rowClassName={(record: any) => record.semesterCode === semesterCode ? 'chosen' : 'pointer'}
            rowKey="semesterCode"
          />
        </div>
        <div className="clearfix flex">
          <div className="w-100">
            <DownloadButton
              onClick={onExportTable}
            />
          </div>
          <div className="common-paging center">
            <Pagination
              count={semesters?.length || 0}
              page={page}
              param={param}
              path="/program/semester"
              small
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SemesterTable;
